// appCountdown.js
//
// Οι ημερομηνίες και η μέτρηση για την προεπισκόπηση της εφαρμογής.
// Χωριστό αρχείο από το appPreview.jsx ώστε εκείνο να εξάγει μόνο components.

import { useEffect, useState } from 'react'

/**
 * Πρώτο μάθημα Πανελλαδικών 2027, Νεοελληνική Γλώσσα.
 * Εκτίμηση από το σταθερό μοτίβο των προηγούμενων ετών (τελευταία Παρασκευή
 * Μαΐου). Το +03:00 είναι ώρα Ελλάδας, ώστε η μέτρηση να βγαίνει σωστή
 * ανεξάρτητα από τη ζώνη ώρας του επισκέπτη.
 */
export const FIRST_EXAM = '2027-05-28T08:30:00+03:00'

/** Η μέτρηση ξεκινάει 1η Ιουλίου, μόλις τελειώσει η προηγούμενη σειρά. */
const CYCLE_START = '2026-07-01T00:00:00+03:00'

const MS_PER_DAY = 86_400_000

function startOfDay(d) {
  return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())
}

export function daysUntil(targetIso, now) {
  return Math.max(0, Math.round((startOfDay(new Date(targetIso)) - startOfDay(now)) / MS_PER_DAY))
}

export function cycleProgress(now) {
  const start = Date.parse(CYCLE_START)
  const end = Date.parse(FIRST_EXAM)
  return Math.min(1, Math.max(0, (now.getTime() - start) / (end - start)))
}

/** Ανανέωση ανά λεπτό: αρκεί για μέτρηση σε μέρες που γυρίζει τα μεσάνυχτα. */
export function useCountdown() {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000)
    return () => clearInterval(id)
  }, [])

  return { days: daysUntil(FIRST_EXAM, now), progress: cycleProgress(now) }
}
